import { render } from "./SortText.vue?vue&type=template&id=42bf4059&scoped=true"
import script from "./SortText.vue?vue&type=script&lang=js"
export * from "./SortText.vue?vue&type=script&lang=js"

import "./SortText.vue?vue&type=style&index=0&id=42bf4059&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bf4059"]])

export default __exports__